<template>
  <div id="myAlert">
    <div class="mask"></div>
    <div class="model">
      <div class="title">{{title}}</div>
      <div class="text">{{ text }}</div>
      <div class="btns">
        <div class="btn btn1" @click="cancel">{{ cancelText }}</div>
        <div class="btn btn2" @click="confirm">{{confirmText}}</div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
export default {
  name: "myAlert",
  props:{
    title: {
      type: String,
      default: "提示"
    },
    text: {
      type: String,
      default: ""
    },
    cancelText: {
      type: String,
      default: "取消"
    },
    confirmText: {
      type: String,
      default: "确定"
    },
  },
  data() {
    return {};
  },
  components: {},
  methods: {
    confirm(){
        this.$emit('confirm')
    },
    cancel(){
        this.$emit('cancel')
    }
  }
};
</script>

<style lang="scss" scoped>
@mixin wh100 {
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}
#myAlert {
  position: fixed;
  @include wh100;
  z-index: 999;
  @include flex_cc;
  .mask {
    @include wh100;
    position: absolute;
    background-color: rgba(0, 0, 0, 0.6);
  }
  .model {
    width: 520px;
    border: 1px solid rgba(255, 255, 255, 0.04);
    background: rgba(43, 43, 47, 1);
    border-radius: 24px;
    position: relative;
    z-index: 10;
    box-sizing: border-box;
    padding: 32px 48px 32px 48px;
    color: #fff;
    .title {
      font-size: 22px;
      font-weight: 700;
      line-height: 38px;
      text-align: center;
      margin-bottom: 24px;
    }
    .text {
      text-align: center;
      font-size: 18px;
      line-height: 28px;
      margin-bottom: 48px;
    }
    .btns {
      @include flex_sb;
      .btn {
        width: 196px;
        height: 44px;
        line-height: 42px;
        text-align: center;
        font-size: 16px;
        // font-weight: 700;
        border-radius: 49px;
        border: 1px solid rgba(0, 0, 0, 0);
        // transition: 0.2s;
        &:active{
            opacity: 0.6;
        }
      }
      .btn1 {
        background: rgba(255, 255, 255, 0.08);
        border: 1px solid;
        border-image-source: linear-gradient(
          119.02deg,
          rgba(255, 255, 255, 0.06) 0.54%,
          rgba(255, 255, 255, 0) 52.08%,
          rgba(255, 255, 255, 0.06) 100%
        );
      }
      .btn2 {
        background-color: #fff;
        color: rgba(10, 10, 10, 1);
      }
    }
  }
}
</style>
